module.exports = __webpack_public_path__ + "static/media/exist-educate.631093cd.png";